import { FetchNextPageOptions, InfiniteData, InfiniteQueryObserverResult } from '@tanstack/react-query';

import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { EIntegratedSearchTabType, ERequestButtonType, KeywordSearchMagazineVo } from '@/types/search';
import { coreLogger } from '@/utils/logger';

import useGetKeywordSearchMagazineInfinite from './useGetKeywordSearchMagazineInfinite';

interface Props {
  keyword: string;
  tab: EIntegratedSearchTabType;
}

export interface SearchMagazineViewModel {
  magazinesData: InfiniteData<KeywordSearchMagazineVo> | undefined;
  isMagazinesLoading: boolean;
  hasMagazinesNextPage: boolean | undefined;
  fetchMagazinesNextPage: (options?: FetchNextPageOptions) => Promise<InfiniteQueryObserverResult>;
  onClickMoveNative: (magazinePid: string) => void;
  onClickLogMagazine: (magazinePid: string) => void;
  handleClickRequestButton: () => void;
}
const useSearchMagazineViewModel = ({ keyword, tab }: Props): SearchMagazineViewModel => {
  const { pageName, moveToPage } = useCustomRouter();

  const { magazinesData, isMagazinesLoading, hasMagazinesNextPage, fetchMagazinesNextPage } =
    useGetKeywordSearchMagazineInfinite({
      keyword,
      enabled: tab === EIntegratedSearchTabType.Magazine,
    });

  const onClickMoveNative = (magazinePid: string) => {
    moveToPage({
      webLink: `${ROUTES.MAGAZINE.DETAIL.path}/${magazinePid}`,
      mobileScreenName: ROUTES.MAGAZINE.DETAIL.appScreenName,
      params: {
        id: magazinePid,
      },
    });
  };
  const onClickLogMagazine = (magazinePid: string) => {
    coreLogger({
      pageName: pageName,
      eventName: 'search_item_click',
      payload: {
        keyword,
        content_id: magazinePid,
        tab: EIntegratedSearchTabType.Magazine,
      },
    });
  };
  const handleClickRequestButton = () => {
    coreLogger({
      eventName: 'request_additional_info_click',
      pageName: pageName,
      payload: {
        position: ERequestButtonType.BOTTOM,
        keyword,
        section_name: 'integrate_search_magazine',
      },
    });
    moveToPage({
      webLink: `${ROUTES.SEARCH(keyword.replaceAll(' ', '+')).REQUEST_INFO.path}`,
      mobileScreenName: ROUTES.SEARCH(keyword.replaceAll(' ', '+')).REQUEST_INFO.appScreenName,
      params: { keyword },
    });
  };
  return {
    magazinesData,
    isMagazinesLoading,
    hasMagazinesNextPage,
    fetchMagazinesNextPage,
    onClickMoveNative,
    onClickLogMagazine,
    handleClickRequestButton,
  };
};

export default useSearchMagazineViewModel;
